import { Box } from '@dealstack/frontend/shared/components/Box/Box';
import { Expandable } from '@dealstack/frontend/shared/components/Expandable/Expandable';
import { Button } from '@dealstack/frontend/shared/components/fundament/Button/Button';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { GenericBooleanStatus } from '@dealstack/frontend/shared/components/GenericStatus/variants/GenericBooleanStatus/GenericBooleanStatus';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import { SectionHeader } from '@dealstack/frontend/shared/components/SectionHeader/SectionHeader';
import { TagText, TagPair } from '@dealstack/frontend/shared/components/TagPair/TagPair';
import { DealArchiveButton } from '@dealstack/frontend/admin/pages/Manage/MIP/ManageDeal/DealArchiveButton/DealArchiveButton';
import { useManageDeal } from '@dealstack/frontend/admin/pages/Manage/MIP/ManageDeal/useManageDeal';
import { GODMODE_ROOT_ROUTES } from '@dealstack/frontend/admin/pages/Routing/Routing';
import { DATE_FORMATS, formatDateToUI } from '@dealstack/shared/lib/format/dates/date';
import { Flex } from '@mantine/core';
import { memo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const ManageDeal = () => {
	const navigate = useNavigate();
	const { isLoading, dealData, dealId, refetchMipData } = useManageDeal();

	const mappedMips = dealData?.mips?.map((mip) => {
		return (
			<li key={mip?.id}>
				<MIPBox>
					<Text>
						{mip?.entity?.displayName}/{mip?.programmeName}
					</Text>
					<ManageMIPButtonWrapper>
						<Link to={`${GODMODE_ROOT_ROUTES.MANAGE_MIP}/mip/${mip.id}`}>
							<Button variant="secondary">Manage</Button>
						</Link>
					</ManageMIPButtonWrapper>
				</MIPBox>
				<br />
			</li>
		);
	});

	return (
		<Flex pos="relative" direction="column" gap="1.5em">
			{isLoading ? <InlineLoader /> : null}

			<Button
				onClick={() => {
					navigate(GODMODE_ROOT_ROUTES.MANAGE_MIP);
				}}
				variant="project"
				style={{ width: 'fit-content' }}
			>
				Back to list
			</Button>
			<Flex gap="2rem" justify="space-between">
				<SectionHeader title={dealData?.name} />
			</Flex>

			<TextWrapper>
				<TagPair title="Deal name">
					<TagText>{dealData?.name}</TagText>
				</TagPair>
				<TagPair title="Target name">
					<TagText>{dealData?.targetName}</TagText>
				</TagPair>
				<TagPair title="is Archived">
					<GenericBooleanStatus value={dealData?.deleted} />
				</TagPair>
				<TagPair title="Creation date">
					<TagText>
						{dealData?.createdAt &&
							formatDateToUI(
								new Date(dealData.createdAt),
								DATE_FORMATS.FULL_DATE_TIME
							)}
					</TagText>
				</TagPair>
			</TextWrapper>

			<Expandable title="Investment Programmes">
				<ul>{mappedMips}</ul>
			</Expandable>

			{!!dealId && (
				<DealArchiveButton
					isDealArchived={!!dealData?.deleted}
					dealId={dealId}
					refetchDealData={refetchMipData}
				/>
			)}
		</Flex>
	);
};

const MIPBox = styled(Box)`
	display: flex;
	align-items: center;
`;

const ManageMIPButtonWrapper = styled.div`
	margin-left: auto;
`;

const TextWrapper = styled.div`
	display: flex;
	align-items: flex-start;
	& > * {
		margin-right: 2rem;
	}
`;
const _ManageDealExport = memo(ManageDeal);

export { _ManageDealExport as ManageDeal };
